// extracted by mini-css-extract-plugin
export var actions = "_u0-4";
export var item = "_u0-1";
export var price = "_u0-3";
export var quantity = "_u0-2";
export var table = "_u0-0";